import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import ProtectedPage from './components/ProtectedPage';
import ProductRedirect from './components/ProductRedirect';
import AuthorizationService from './service/AuthorizationService';

export default function UtilityRoutes() {
  return (
    <Switch>
      <Route path="/eg/u/auth" component={ProtectedPage.AuthPreProcessor} />
      <Route path="/eg/u/redirect" component={ProductRedirect} />
      <Route
        path="/eg/u/logout"
        render={() => {
          AuthorizationService.logOut();
          window.location = process.env.LOG_OUT;
          return null;
        }}
      />
      <Redirect to="/eg/404" />
    </Switch>
  );
}
